import { createTheme } from '@mui/material/styles';
import { esES } from '@mui/material/locale';

// Paleta HolaVeci Local — la misma identidad de HolaVeci (landing y web):
// verde tienda + amarillo maduro + terracota, sobre crema.
export const colores = {
  verde:        '#0F4C3A',
  verdeClaro:   '#2E6E5A',
  verdeOscuro:  '#083025',
  amarillo:     '#F4B23C',
  terracota:    '#E85D3B',
  crema:        '#FBF7F0',
};

const palette = {
  mode: 'light',
  primary: {
    main: colores.verde,
    light: colores.verdeClaro,
    dark: colores.verdeOscuro,
    contrastText: colores.crema,
  },
  secondary: {
    main: colores.amarillo,
    light: '#F8C868',
    dark: '#C9902A',
    contrastText: '#0F2A22',
  },
  error:   { main: '#C0392B' },
  warning: { main: colores.terracota },
  success: { main: '#2E7D5B' },
  info:    { main: '#3A6EA5' },
  background: {
    default: colores.crema,
    paper: '#FFFFFF',
  },
  text: {
    primary: '#1A1E1C',
    secondary: '#5A605D',
  },
  divider: 'rgba(15, 76, 58, 0.14)',
};

const theme = createTheme(
  {
    palette,
    shape: { borderRadius: 12 },
    typography: {
      fontFamily: `"DM Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif`,
      h1: { fontFamily: `"Fraunces", Georgia, serif`, fontWeight: 600, letterSpacing: '-0.02em' },
      h2: { fontFamily: `"Fraunces", Georgia, serif`, fontWeight: 600, letterSpacing: '-0.02em' },
      h3: { fontFamily: `"Fraunces", Georgia, serif`, fontWeight: 600, letterSpacing: '-0.01em' },
      h4: { fontFamily: `"Fraunces", Georgia, serif`, fontWeight: 600, letterSpacing: '-0.01em' },
      h5: { fontFamily: `"Fraunces", Georgia, serif`, fontWeight: 600 },
      h6: { fontFamily: `"DM Sans", sans-serif`, fontWeight: 600, letterSpacing: '0.01em' },
      button: { textTransform: 'none', fontWeight: 600, letterSpacing: '0.01em' },
      overline: { fontWeight: 600, letterSpacing: '0.12em' },
    },
    components: {
      MuiButton: {
        styleOverrides: {
          root: {
            borderRadius: 10,
            paddingLeft: 16,
            paddingRight: 16,
            boxShadow: 'none',
            '&:hover': { boxShadow: 'none' },
          },
          containedPrimary: {
            '&:hover': { backgroundColor: palette.primary.dark },
          },
        },
      },
      MuiPaper: {
        styleOverrides: { root: { backgroundImage: 'none' } },
      },
      MuiCard: {
        styleOverrides: {
          root: {
            border: `1px solid ${palette.divider}`,
            borderRadius: 14,
            boxShadow: 'none',
          },
        },
      },
      MuiAppBar: {
        styleOverrides: {
          root: {
            backgroundColor: colores.crema,
            color: palette.text.primary,
            borderBottom: `1px solid ${palette.divider}`,
            boxShadow: 'none',
          },
        },
      },
      MuiDrawer: {
        styleOverrides: {
          paper: { backgroundColor: '#FFFFFF', borderRight: `1px solid ${palette.divider}` },
        },
      },
      MuiListItemButton: {
        styleOverrides: {
          root: {
            '&.Mui-selected': {
              backgroundColor: 'rgba(15, 76, 58, 0.10)',
              color: colores.verde,
              '& .MuiListItemIcon-root': { color: colores.verde },
            },
            '&.Mui-selected:hover': { backgroundColor: 'rgba(15, 76, 58, 0.16)' },
          },
        },
      },
      MuiChip: {
        styleOverrides: { root: { fontWeight: 500 } },
      },
      MuiTableCell: {
        styleOverrides: {
          head: { fontWeight: 600, backgroundColor: 'rgba(15, 76, 58, 0.04)' },
        },
      },
    },
  },
  esES
);

export default theme;
